module.exports = __webpack_public_path__ + "img/logo-m.f1fde89f.svg";